export default (kasko) => {
  const isLiveMode = window.kaskoConfig.publicKey.startsWith('pk_live_');
  if (!isLiveMode) {
    return;
  }

  const itemsToNameMapping = {
    item_5994788bf965810034710f40159: 'hausratsversicherung',
    item_5a3905dc363122c6e5c8474e212: 'privathaftversicherung',
    item_584a39bbf525ae7e16872650e69: 'gebäudeversicherung',
    item_957711384345569b02c8ad7cc7a: 'hausratsversicherung, privathaftversicherung',
    item_18127b9f3c3ade0df4330aa9bd8: 'privathaftversicherung, gebäudeversicherung',
    item_5991be0f8150e87e8663b49d2ac: 'hausratsversicherung, gebäudeversicherung',
    item_7e644b3be4c54b18c53e7138511: 'produktkombinationen',
  };

  const getGrossPremium = (itemId, extraData = {}) => {
    const {
      yearly_gross_premium,
      yearly_building_gross_premium,
      yearly_private_liability_gross_premium,
      yearly_gross_premium_building_privateliability,
      yearly_gross_premium_contents_building,
    } = extraData;

    const itemToPremiumMapping = {
      item_5994788bf965810034710f40159: yearly_gross_premium,
      item_5a3905dc363122c6e5c8474e212: yearly_private_liability_gross_premium,
      item_584a39bbf525ae7e16872650e69: yearly_building_gross_premium,
      item_957711384345569b02c8ad7cc7a: yearly_gross_premium,
      item_18127b9f3c3ade0df4330aa9bd8: yearly_gross_premium_building_privateliability,
      item_5991be0f8150e87e8663b49d2ac:
        yearly_gross_premium_contents_building || yearly_gross_premium,
      item_7e644b3be4c54b18c53e7138511: yearly_gross_premium,
    };

    return itemToPremiumMapping[itemId];
  };

  kasko.addEventListener('route-changed', ({ previous, current }) => {
    const currentScreen = current?.path;
    const { is_first_event_pushed } = kasko.getState('flags');
    // Basic check to avoid pushing events when not needed

    if (
      !window.dataLayer ||
      !currentScreen ||
      (currentScreen === 'init' && is_first_event_pushed) ||
      previous?.path === currentScreen
    ) {
      return;
    }

    // We set initial event when we are in init screen
    if (currentScreen === 'initial' && !is_first_event_pushed) {
      window.dataLayer.push({
        event: 'offer_start_directa',
      });
      kasko.dispatchEvent('set-flag', { is_first_event_pushed: true });
      return;
    }

    const { item_id } = kasko.getState('input');

    // Handles offer_select_type_directa case
    if (
      previous?.path === 'initial' &&
      (currentScreen === 'start' ||
        currentScreen === 'private-liability-start' ||
        currentScreen === 'buildings-start')
    ) {
      const offerSelectTypeDirecta = {
        event: 'offer_select_type_directa',
        directa_type: itemsToNameMapping[item_id],
      };

      window.dataLayer.push(offerSelectTypeDirecta);
      return;
    }

    // Handles offer_view_options_directa case
    if (
      (previous?.path === 'loading' && currentScreen === 'risk-questions-1') ||
      (previous?.path === 'risk-questions-1' && currentScreen === 'risk-questions-2')
    ) {
      const offerViewOptionsDirecta = {
        event: 'offer_view_options_directa',
        directa_type: itemsToNameMapping[item_id],
      };

      window.dataLayer.push(offerViewOptionsDirecta);

      return;
    }

    if (
      (previous?.path !== 'summary' && currentScreen === 'summary') ||
      (previous?.path !== 'private-liability-summary' &&
        currentScreen === 'private-liability-summary') ||
      (previous?.path !== 'buildings-summary' && currentScreen === 'buildings-summary') ||
      (previous?.path !== 'common-summary' && currentScreen === 'common-summary')
    ) {
      const offerPreviewDirecta = {
        event: 'offer_preview_directa',
        directa_type: itemsToNameMapping[item_id],
      };

      window.dataLayer.push(offerPreviewDirecta);
      return;
    }

    if (
      (previous?.path === 'summary' && currentScreen === 'personal-info') ||
      (previous?.path === 'buildings-summary' && currentScreen === 'buildings-personal-info') ||
      (previous?.path === 'private-liability-summary' &&
        currentScreen === 'private-liability-personal-info') ||
      (previous?.path === 'common-summary' && currentScreen === 'common-personal-info')
    ) {
      const { extraData } = kasko.getState('quote.data') || {};

      const offerStateConfirmationDirecta = {
        event: 'offer_start_confirmation_directa',
        directa_type: itemsToNameMapping[item_id],
        value: getGrossPremium(item_id, extraData),
        offer_type: 'directa_closing',
      };

      window.dataLayer.push(offerStateConfirmationDirecta);
      return;
    }

    if (previous?.path !== 'save-later-success' && currentScreen === 'save-later-success') {
      const { extraData } = kasko.getState('quote.data') || {};

      const offerStateConfirmationDirecta = {
        event: 'offer_confirm_directa',
        directa_type: itemsToNameMapping[item_id],
        value: getGrossPremium(item_id, extraData),
        offer_type: 'directa_quote',
      };

      window.dataLayer.push(offerStateConfirmationDirecta);
      return;
    }

    //common-sucess, private-liability-success, buildings-success
    if (
      (previous?.path !== 'success' && currentScreen === 'success') ||
      (previous?.path !== 'common-success' && currentScreen === 'common-success') ||
      (previous?.path !== 'private-liability-success' &&
        currentScreen === 'private-liability-success') ||
      (previous?.path !== 'buildings-success' && currentScreen === 'buildings-success')
    ) {
      const { extraData } = kasko.getState('quote.data') || {};

      const offerStateConfirmationDirecta = {
        event: 'offer_confirm_directa',
        directa_type: itemsToNameMapping[item_id],
        value: getGrossPremium(item_id, extraData),
        offer_type: 'directa_closing',
      };

      window.dataLayer.push(offerStateConfirmationDirecta);
      return;
    }
  });
};
